export default factory

const defaultMediaOptions = {
  image: {
    showCaption: true,
    showSubtitle: true,
    showLink: true,
  },
  video: {
    showTitle: true,
    showBlurb: true,
    showTease: true,
  },
  gallery: {
    showTitle: true,
    showDescription: true,
  },
}

const merge = (model = {}, delta = {}, defaults = defaultMediaOptions) => ({
  image: Object.assign({}, defaults.image, model.image, delta.image),
  video: Object.assign({}, defaults.video, model.video, delta.video),
  gallery: Object.assign({}, defaults.gallery, model.gallery, delta.gallery),
})

function factory(settings) {
  settings.mediaOptions = settings.mediaOptions || {}

  // obj is current viewmodel state ( read-only )
  let obj = merge(settings.mediaOptions) // build object from scope

  // apply deltas, save to scope, update obj reference
  const update = () => {
    console.log({ hey: 'mediaOptions update', obj })
    Object.assign(settings.mediaOptions, obj) // put back to original settings object
    // TODO find a better way to get changes back to original ref, maybe in settingsModel/index.js
  }

  return {
    image: obj.image,
    video: obj.video,
    gallery: obj.gallery,
    get noImageFields() {
      return (
        !obj.image.showCaption && !obj.image.showSubtitle && !obj.image.showLink
      )
    },
    get noVideoFields() {
      return (
        !obj.video.showTitle && !obj.video.showBlurb && !obj.video.showTease
      )
    },
    get noGalleryFields() {
      return !obj.gallery.showTitle && !obj.gallery.showDescription
    },
    update,
  }
}
